<template>
  <SelectBox
    optionField="name"
    @open="getBatteries"
    @search="getBatteries"
    @option:selected="$emit('option:selected', $event)"
    :options="items"
    :validActivated="validActivated"
    :label="label"
    :noLabel="noLabel"
    :value="value"
    :clearable="clearable"
    searchable
    @input="$emit('input', $event)"
  ></SelectBox>
</template>

<script>
import Requests from "@/services/Requests";
import SelectBox from "../Base/Inputs/SelectBox.vue";
export default {
  components: {
    SelectBox,
  },
  data() {
    return {
      items: [],
    };
  },
  props: {
    value: {
      default: null,
    },
    clearable: {
      default: false,
      type: Boolean,
    },
    noLabel: {
      default: false,
      type: Boolean,
    },
    searchable: {
      default: false,
      type: Boolean,
    },
    label: {
      type: String,
      required: true,
    },
    validActivated: {
      default: false,
      type: Boolean,
    },
    type: {
      default: "",
      type: String,
      required: true,
    },
  },
  methods: {
    /*************  ✨ Codeium Command ⭐  *************/
    /**
     * Makes a request to get all batteries that match the given search query.
     *
     * @param {string} search - search query to send to the API
     * @param {function} loading - function to call when the request is sending or done. Pass true to indicate sending, false to indicate done.
     */
    /******  0ee3ea39-a105-45dc-a4e8-b028140daac4  *******/ async getBatteries(
      search,
      loading
    ) {
      loading(true);
      const response = await Requests.Battery.GetBatteryList({
        query: { type: this.type, search: search },
      });
      if (response.message === "OK") {
        this.items = response.data.items;
      } else {
        this.items = [];
      }
      loading(false);
    },
  },
};
</script>

<style></style>
